<template>
  <div class="limited-task-item">
    <p class="task-title">
      {{ getTaskName }}
    </p>
    <div class="task-content">
      <div class="content-left">
        <p class="content-process" v-if="task.limitedPay">
          {{ getTaskProcess }}
        </p>
        <p class="content-process" v-else="task.limitedPay">
          ( {{ task.status === 0 ? 0 : 1 }}/1)
        </p>
        <a
          class="content-btn claim-btn"
          href="javascript:;"
          v-if="task.status === 1"
          @click="toGetAward"
          >{{ letter.limitedTimeActivityClaim }}</a
        >
        <a
          class="content-btn claimed-btn"
          href="javascript:;"
          v-if="task.status === 2"
          >{{ letter.limitedTimeActivityClaimed }}</a
        >
        <a
          class="content-btn not-achieve-btn"
          href="javascript:;"
          v-if="task.status === 0"
          >{{ letter.limitedTimeActivityNotAchieve }}</a
        >
        <p class="content-time" v-if="task.limitedTime === 'weekly'">
          {{ _weeklyTime }}
        </p>
        <p class="content-time" v-if="task.limitedTime === 'monthly'">
          {{ _monthlyTime }}
        </p>
      </div>
      <div class="content-right">
        <div class="award-content" @click="checkAwardDetail">
          <img class="award-icon" :src="award.icon" alt="" />
          <span class="award-num">{{ award.num || '' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState } from 'vuex';
import {
  countDownTimeFormat,
  timestampToDateFormat
} from '@utiles/officialStore';
export default {
  name: 'LimitedTimeTaskListItem',
  props: ['task', 'monthlyTime', 'weeklyTime', 'payMonth'],
  mixins: [],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      showCurrency: state => state.showCurrency,
      limitedTimeActivityMonthStart: state =>
        state.event.limitedTimeActivityMonthStart,
      limitedTimeActivityMonthEnd: state =>
        state.event.limitedTimeActivityMonthEnd
    }),
    award() {
      return this.task.award[0];
    },
    _weeklyTime() {
      const { days, hours, minutes, seconds } = countDownTimeFormat(
        this.weeklyTime
      );
      return this.letter.limitedTimeActivityTimeLeft
        .replace('${days}', days)
        .replace('${hours}', hours)
        .replace('${minutes}', minutes)
        .replace('${seconds}', seconds);
    },
    _monthlyTime() {
      const { days, hours, minutes, seconds } = countDownTimeFormat(
        this.monthlyTime
      );
      return this.letter.limitedTimeActivityTimeLeft
        .replace('${days}', days)
        .replace('${hours}', hours)
        .replace('${minutes}', minutes)
        .replace('${seconds}', seconds);
    },
    limitedTimeActivityTime() {
      const startDate = timestampToDateFormat(
        this.limitedTimeActivityMonthStart
      );
      const endDate = timestampToDateFormat(this.limitedTimeActivityMonthEnd);
      return this.letter.limitedTimeActivityTime
        .replace('${startDate}', startDate)
        .replace('${endDate}', endDate);
    },
    getTaskProcess() {
      return this.letter.limitedTimeActivityTaskProcess
        .replace('${curPay}', this.payMonth)
        .replace('${targetPay}', this.task.pay);
    },
    getTaskName() {
      return this.task.taskName
        .replace('${price}', this.task.pay)
        .replace('${currency}', this.showCurrency);
    }
  },
  methods: {
    checkAwardDetail() {
      this.$emit('checkAwardDetail', this.task.awardDetail);
    },
    toGetAward() {
      this.$emit('toGetAward', this.task);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-task-item {
  background-size: cover;
  background-repeat: no-repeat;
  @psetbg ("limited-time-item-bg.png", false, false);
  width: 296px;
  padding: 26px 23px 19px 21px;

  .task {
    &-title {
      font-size: 18px;
      line-height: 24px;
      height: 40px;
      color: var(--limited-time-activity-task-title);
    }

    &-content {
      margin-top: 8px;
      display: flex;
      justify-content: space-between;

      .content-left {
        .content-process {
          word-break: break-word;
          width: 100%;
          font-size: 18px;
          line-height: 24px;
          color: var(--limited-time-activity-task-content);
        }

        .content-btn {
          margin-top: 23px;
          font-size: 18px;
          color: var(--limited-time-activity-task-title);
          display: flex;
          justify-content: center;
          align-items: center;
          white-space: nowrap;

          &.claim-btn {
            background-size: cover;
            background-repeat: no-repeat;
            @psetbg ("limited-time-claim-btn.png");
          }
          &.claimed-btn {
            background-size: cover;
            background-repeat: no-repeat;
            @psetbg ("limited-time-claimed-btn.png");
          }
          &.not-achieve-btn {
            background-size: cover;
            background-repeat: no-repeat;
            @psetbg ("limited-time-not-achieve-btn.png");
          }
        }

        .content-time {
          margin-top: 8px;
          font-size: 15px;
          color: var(--limited-time-activity-task-content);
        }
      }

      .content-right {
        cursor: pointer;

        .award-content {
          position: relative;
          width: 90px;
          height: 90px;
          background-size: cover;
          background-repeat: no-repeat;
          @psetbg ('prop-item-bg.png', false, false);
          display: flex;
          justify-self: center;
          align-items: center;

          .award-icon {
            width: 100%;
            height: 100%;
          }

          .award-num {
            position: absolute;
            right: 5px;
            top: 5px;
            font-size: 19px;
            color: var(--product-item-prop-num);
          }
        }
      }
    }
  }
}
@media screen and (orientation: landscape) {
  .limited-task-item {
    width: 339px;
    padding: 27px 26px 21px 23px;
  }
}
</style>
